import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn } from '../../helper'
const state = {
  name: 'abcs'
}
const actions = {
    getCustomerSupport: (context, filterData) => {
    let url = '/subscriber/v1/ticket'
    return new Promise( (resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        if (context.getters.getMode == "development") {
          resolve()
        } else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve()
          return
        }
        reject(error)
      });
    });
  },
  actCloseTicket: (context, filterData) => {
    let url = '/subscriber/v1/ticket/'
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + url + filterData, {
        method: 'PUT',
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        console.log("phase 2")
        if (context.getters.getMode == "development") {
          resolve({"success":"3939244"})
        } else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve({"success":"3939244"})
          return
        }
        reject(error)
      });
    });
  },
  getTicketCategory: (context) => {
    let url = '/subscriber/v1/ticket/category'
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        console.log("phase 2")
        if (context.getters.getMode == "development") {
          resolve([{"idcategory":"BIL01","description":"BILLING","subcategory":[{"idcategory":"BIL01001","description":"Bill Not Received"},{"idcategory":"BIL01011","description":"Wrong Rentals charged for Set Top Box"},{"idcategory":"BIL01012","description":"Wrong or Excess Bill received"}]},{"idcategory":"HWR01","description":"HARDWARE","subcategory":[{"idcategory":"HWR01001","description":"Remote Not Functioning"},{"idcategory":"HWR01002","description":"STB Hang "},{"idcategory":"HWR01003","description":"Smartcard Inserted Up-side Down or Smartcard Communication Error"},{"idcategory":"HWR01004","description":"STB Dead (Green Light Not Glowing)"},{"idcategory":"HWR01005","description":"Channels not getting Auto Scanned"},{"idcategory":"HWR01006","description":"No Audio in All Channels"},{"idcategory":"HWR01007","description":"No Video in All Channels (All Channels Blank) "},{"idcategory":"HWR01008","description":"Negative Video"}]},{"idcategory":"MOD","description":"MODIFICATION","subcategory":[{"idcategory":"MOD01001","description":"Customer Name Wrong or Mismatch"},{"idcategory":"MOD01002","description":"Change in Address \/ Wrong Address"},{"idcategory":"MOD01003","description":"Change in Contact Nos. \/ New Contact Nos."},{"idcategory":"MOD01004","description":"Hardware Mismatch"}]},{"idcategory":"ORD01","description":"ORDER","subcategory":[{"idcategory":"ORD01001","description":"Addition of Channels \/ Changes in A La Carte"},{"idcategory":"ORD01002","description":"Additional Set Top Box required"},{"idcategory":"ORD01003","description":"New Set Top Box required"},{"idcategory":"ORD01004","description":"New Connection required"},{"idcategory":"ORD01005","description":"Shifting to New Premises"},{"idcategory":"ORD01006","description":"Addition of Package \/ Changes in Package"},{"idcategory":"ORD01007","description":"New Activation Request"},{"idcategory":"ORD01008","description":"Temporary Deactivation Request"},{"idcategory":"ORD01009","description":"Permanent Deactivation Request"},{"idcategory":"ORD01010","description":"Reconnection Request"}]},{"idcategory":"SER01","description":"SERVICE","subcategory":[{"idcategory":"SER01001","description":"Access Denied or Channel Not Subscribed"},{"idcategory":"SER01003","description":"Channels Freezing (Channels get Stuck)"},{"idcategory":"SER01005","description":"Less Channels Available"},{"idcategory":"SER01007","description":"No Audio in One or Few Channels"},{"idcategory":"SER01008","description":"No Signal in One or Few Channels"},{"idcategory":"SER01009","description":"No Video in One or Few Channels"},{"idcategory":"SER01010","description":"No Signal in All Channels"},{"idcategory":"SER01011","description":"Cracking (Disturbance ) in Audio"},{"idcategory":"SER01012","description":"Reconnection \/ Disconnection"},{"idcategory":"SER01013","description":"Fiber cut"},{"idcategory":"SER01014","description":"Low signal strength"},{"idcategory":"SER01015","description":"Error-1"},{"idcategory":"SER01016","description":"Error-5"}]}])
        } else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          // resolve([{"idcategory":"BIL01","description":"BILLING","subcategory":[{"idcategory":"BIL01001","description":"Bill Not Received"},{"idcategory":"BIL01011","description":"Wrong Rentals charged for Set Top Box"},{"idcategory":"BIL01012","description":"Wrong or Excess Bill received"}]},{"idcategory":"HWR01","description":"HARDWARE","subcategory":[{"idcategory":"HWR01001","description":"Remote Not Functioning"},{"idcategory":"HWR01002","description":"STB Hang "},{"idcategory":"HWR01003","description":"Smartcard Inserted Up-side Down or Smartcard Communication Error"},{"idcategory":"HWR01004","description":"STB Dead (Green Light Not Glowing)"},{"idcategory":"HWR01005","description":"Channels not getting Auto Scanned"},{"idcategory":"HWR01006","description":"No Audio in All Channels"},{"idcategory":"HWR01007","description":"No Video in All Channels (All Channels Blank) "},{"idcategory":"HWR01008","description":"Negative Video"}]},{"idcategory":"MOD","description":"MODIFICATION","subcategory":[{"idcategory":"MOD01001","description":"Customer Name Wrong or Mismatch"},{"idcategory":"MOD01002","description":"Change in Address \/ Wrong Address"},{"idcategory":"MOD01003","description":"Change in Contact Nos. \/ New Contact Nos."},{"idcategory":"MOD01004","description":"Hardware Mismatch"}]},{"idcategory":"ORD01","description":"ORDER","subcategory":[{"idcategory":"ORD01001","description":"Addition of Channels \/ Changes in A La Carte"},{"idcategory":"ORD01002","description":"Additional Set Top Box required"},{"idcategory":"ORD01003","description":"New Set Top Box required"},{"idcategory":"ORD01004","description":"New Connection required"},{"idcategory":"ORD01005","description":"Shifting to New Premises"},{"idcategory":"ORD01006","description":"Addition of Package \/ Changes in Package"},{"idcategory":"ORD01007","description":"New Activation Request"},{"idcategory":"ORD01008","description":"Temporary Deactivation Request"},{"idcategory":"ORD01009","description":"Permanent Deactivation Request"},{"idcategory":"ORD01010","description":"Reconnection Request"}]},{"idcategory":"SER01","description":"SERVICE","subcategory":[{"idcategory":"SER01001","description":"Access Denied or Channel Not Subscribed"},{"idcategory":"SER01003","description":"Channels Freezing (Channels get Stuck)"},{"idcategory":"SER01005","description":"Less Channels Available"},{"idcategory":"SER01007","description":"No Audio in One or Few Channels"},{"idcategory":"SER01008","description":"No Signal in One or Few Channels"},{"idcategory":"SER01009","description":"No Video in One or Few Channels"},{"idcategory":"SER01010","description":"No Signal in All Channels"},{"idcategory":"SER01011","description":"Cracking (Disturbance ) in Audio"},{"idcategory":"SER01012","description":"Reconnection \/ Disconnection"},{"idcategory":"SER01013","description":"Fiber cut"},{"idcategory":"SER01014","description":"Low signal strength"},{"idcategory":"SER01015","description":"Error-1"},{"idcategory":"SER01016","description":"Error-5"}]}])
          return
        }
        reject(error)
      });
    });
  },
  addCreateTicket: (context, payload) => {
    console.log(payload)
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload);
      console.log(data)
      fetch(context.getters.baseUrl + "/subscriber/v1/ticket", {
        method: "POST",
        body: data
      }).then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        console.log("phase 2")
        if (context.getters.getMode == "development") {
          resolve({"ticketid":"3939244"})
        } else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve({"ticketid":"3939244"})
          return
        }
        reject(error)
      });
    });
  },
  getContactMethod: (context) => {
    let url = '/subscriber/v1/ticket.php/contactmethods'
    return new Promise((resolve, reject) => {
      fetch(context.getters.baseUrl + url, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        console.log("phase 2")
        if (context.getters.getMode == "development") {
          resolve([{"contactmethod":"S","contactmethodname":"SMS","description":"SMS","status":true},{"contactmethod":"P","contactmethodname":"Phone","description":"Phone","status":true},{"contactmethod":"O","contactmethodname":"OSD","description":"On Screen Display Message","status":true},{"contactmethod":"E","contactmethodname":"Email","description":"Emial","status":true},{"contactmethod":"B","contactmethodname":"Bmail","description":"Broadcast Mail Message","status":true}])
        } else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve([{"contactmethod":"S","contactmethodname":"SMS","description":"SMS","status":true},{"contactmethod":"P","contactmethodname":"Phone","description":"Phone","status":true},{"contactmethod":"O","contactmethodname":"OSD","description":"On Screen Display Message","status":true},{"contactmethod":"E","contactmethodname":"Email","description":"Emial","status":true},{"contactmethod":"B","contactmethodname":"Bmail","description":"Broadcast Mail Message","status":true}])
          return
        }
        reject(error)
      });
    });
  }
};
/*const getters = {
  getCus: (state) => {
   console.log("state.baseUrl ===========>",state)
    return state.baseUrl;
  }
}*/
export default {
  state, actions
};


// WEBPACK FOOTER //
// ./src/store/modules/help/customerSupport.js